import { Input } from "antd";
import { observer } from "mobx-react-lite";
import { useEffect, useState } from "react";
import { MyColor } from "../../config/myStyle";
import { campaignStore } from "../../stores";
import PageBox from "../../layout/PageBox";
import { SearchOutlined } from '@ant-design/icons';
import { useNavigate } from "react-router-dom";
import HomeCampaignItem from "../Home/HomeCampaignItem";
import { useTranslation } from "react-i18next";

const Donation = observer(() => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [searchText, setSearchText] = useState('')

    useEffect(() => {
        campaignStore.getCampaignList({ limit: 3000 })
    }, [])

    const campaignList = campaignStore.campaignList

    const onSearch = () => {
        campaignStore.getCampaignList({ limit: 3000, keyword: searchText || undefined })
    }

    return (
        <PageBox
            spinning={campaignStore.campaignListStatus.loading}
        >
            <div className="flex-col w-full pb-[40px] " >
                <div className="flex-col text-[18px] font-[500] px-[20px]"
                    style={{ color: MyColor.blue }}
                >
                    <div>{t("donation.current_fundraising_event")}</div>
                    <Input
                        onChange={e => setSearchText(e.target.value)}
                        placeholder={t("donation.search_placeholder")}
                        suffix={(
                            <div
                                className="flex" style={{ height: 32, width: 30, justifyContent: 'space-between' }}
                                onClick={onSearch}
                            >
                                <div style={{ minHeight: '100%', width: 1, backgroundColor: 'rgba(0,0,0,0.4)' }} />
                                <SearchOutlined style={{ color: MyColor.blue, fontSize: 20 }} />
                            </div>
                        )} />

                </div>

                {/* 活动列表 */}
                {campaignList.length ? (
                    <div className="flex flex-col  space-y-[25px] pt-[20px] w-full mb-[60px] " style={{ alignItems: 'center' }}>
                        {campaignList.map((campaign, index) => (
                            <HomeCampaignItem
                                key={index}
                                campaign={campaign}
                                onClick={(campaignId) => navigate(`/campaign/${campaignId}`)}
                            />
                        ))}
                    </div>
                ) : <div />}

            </div>
        </PageBox>
    );
})

export default Donation;
